import React, { useState } from 'react';
import { Box, TextField } from '@mui/material';
import Link from 'mui/components/elements/Link';
import DS_ButtonLink from 'mui/components/elements/DS_ButtonLink';
import LoginService from '../../../../../../services/LoginService';
import { StyledWrapper, StyledErrorMessage } from './LoginStyles';
import urlForgotPassword from './forgotPassword/links';

const Login = ({ setAuthToken, emailLabel, emailError, loginButtonLabel, failedLoginMessage, forgotPassword }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isEmailValid, setIsEmailValid] = useState(false);
  const [error, setError] = useState(false);

  const isValidEmail = email => {
    return /\S+@\S+\.\S+/.test(email);
  };
  const handleSubmit = async event => {
    event.preventDefault();

    try {
      const response = await LoginService.loginUser(email, password);
      if (!error) {
        setAuthToken(response.data.refresh_token);
        setError(false);
      }

      if (response.error) {
        console.log('response.error', response);
        setError(true);
      }
    } catch (error) {
      console.log('error', error);
      setError(true);
    }
  };

  const handleEmailChange = event => {
    setError(false);
    const emailValue = event.target.value;
    setEmail(emailValue);
    setIsEmailValid(isValidEmail(emailValue));
  };

  const handlePasswordChange = event => {
    setError(false);
    setPassword(event.target.value);
  };

  const isFormValid = email && password && isEmailValid;
  return (
    <StyledWrapper>
      <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
        <TextField
          margin="normal"
          required
          fullWidth
          id="email"
          label={emailLabel}
          name="email"
          autoComplete="email"
          onChange={handleEmailChange}
          error={!isEmailValid && email.length > 0}
          helperText={!isEmailValid && email.length > 0 ? emailError || 'please enter valid email' : ''}
        />
        <TextField
          margin="normal"
          required
          fullWidth
          name="password"
          label="Password"
          type="password"
          id="password"
          autoComplete="current-password"
          value={password}
          onChange={handlePasswordChange}
        />
        <DS_ButtonLink
          type="submit"
          fullWidth
          variant="contained"
          title={loginButtonLabel || 'sign in'}
          disabled={!isFormValid}
        />
        {error && (
          <StyledErrorMessage component="p" variant="DS_copyMediumBold">
            {failedLoginMessage || 'Login Failed'}
          </StyledErrorMessage>
        )}
        <Link url={urlForgotPassword[[process.env.GATSBY_COUNTRY_CODE]]}>{forgotPassword || 'forgot password'}</Link>
      </Box>
    </StyledWrapper>
  );
};

export default Login;
